<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer003">
<h1 class="Hidden-Title"><a id="_idTextAnchor001"></a>Copyright</h1>
<p class="centered"><em class="Emphasis _idGenCharOverride-1">Car and Driver Iconic Cars: Porsche</em></p>
<p class="centered">Copyright © 2015 by Hearst Magazines</p>
<p class="centered">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</p>
<p class="centered">Electronic edition published 2015 by RosettaBooks</p>
<p class="centered">Cover photo by Tom Salt<br/>Edited by Austin Irwin</p>
<p class="centered">ISBN (EPUB): 9780795347450<br/>ISBN (Kindle): 9780795347467</p>
<p class="centered">www.RosettaBooks.com</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Porsche__1__Copyright.vue?2124b8f7